/* eslint-disable react/display-name */
import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { DynamicField, Button } from '@totalsoft/rocket-ui';
import { addPropertyPrefix } from 'utils/propertyChangeAdapters';
import BrowserContainer from 'components/common/browser/components/BrowserContainer';
import { getDynamicFieldControlType } from 'utils/functions';

const Report = ({ t, report, onPropertyChange, onGenerateReport, reportGenerating, loadOptions, loadBrowser, loadBrowserData }) => {
  const filters = report.document.filters;
  const validationInfo = report.validationInfo.filters;
  const isValid = !validationInfo || validationInfo.isValid;

  const browser = (filter, _idx) => (onPropertyChange, other) =>
  (
    <BrowserContainer
      browserId={filter.adaptiveId}
      loadBrowser={loadBrowser(filter.reportFilterId)}
      loadBrowserData={loadBrowserData(filter.reportFilterId)}
      onChange={onPropertyChange}
      {...other}
    />
  );
  const externalInputs = (filter, idx) => [{ component: browser(filter, idx), controlType: 'BROWSER' }];

  return (
    <Grid container spacing={2}>
      {filters &&
        filters.map((filter, idx) => (
          <Grid item xs={12} md={6} key={filter.reportFilterId}>
            <DynamicField
              id={filter.reportFilterId}
              error={Boolean(validationInfo && validationInfo[idx] && validationInfo[idx].value)}
              label={filter.filterCaption}
              controlType={getDynamicFieldControlType(filter.filterType.dynamicInputControlType)}
              onChange={addPropertyPrefix(idx, onPropertyChange)('value')}
              value={filter?.value}
              valueLabel={filter.value?.label ? filter.value.label : ''}
              valueKey={'value'}
              labelKey={'label'}
              isClearable
              required={!filter.allowNull}
              loadOptions={() => loadOptions(filter.reportFilterId)}
              externalInputs={externalInputs(filter, idx)}
              isMultiSelection={filter.allowMultipleSelection}
            />
          </Grid>
        ))}
      <Grid item xs={12}>
        <Button onClick={onGenerateReport} disabled={reportGenerating || !isValid}>
          {reportGenerating ? t('Reports.GeneratingReport') : t('Reports.GenerateReport')}
        </Button>
      </Grid>
    </Grid>
  );
};

Report.displayName = 'Report';
Report.propTypes = {
  t: PropTypes.func.isRequired,
  report: PropTypes.object,
  onPropertyChange: PropTypes.func.isRequired,
  onGenerateReport: PropTypes.func.isRequired,
  reportGenerating: PropTypes.bool,
  loadOptions: PropTypes.func,
  loadBrowser: PropTypes.func.isRequired,
  loadBrowserData: PropTypes.func.isRequired
};

export default withTranslation()(Report);
